// we use numbers instead of undefined so that angular @for can track them efficiently
export const getNumberedArray = (count: number) => Array.from({ length: count }, (_, i) => i + 1);
